import React, { FC, useEffect, HTMLAttributes, useContext } from 'react'

import { CarouselContext } from './utils'

interface CarouselContentProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

const CarouselContent: FC<React.PropsWithChildren<CarouselContentProps>> = ({ children, ...props }) => {
  const { selectedItem, setItemCount } = useContext(CarouselContext)
  const ItemToDisplay = React.Children.toArray(children)[selectedItem]

  // Save item count in parent component
  useEffect(() => setItemCount(React.Children.count(children)), [children, setItemCount])

  return <div {...props}>{ItemToDisplay}</div>
}

export default CarouselContent
